import { render } from "./ModalWrapper.vue?vue&type=template&id=b1f1faca"
import script from "./ModalWrapper.vue?vue&type=script&lang=js"
export * from "./ModalWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/star-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__